<template>
    <div class="loader-container" v-if="loading">
      <div class="flex items-center justify-center ">
          <div class="w-16 h-16 border-b-2 border-gray-900 rounded-full animate-spin"></div>
      </div>
    </div>
</template>


<script>
    export default {
      props: {
        loading: {
          type: Boolean,
          default: false
        },
        fullPage:{
          type: Boolean,
          default: false
        }
      }
    };
</script>
